import axios from "axios";
import { showToast, getCaption } from "../mixins/Common";
import { store } from "../store/store";
import router from "../router/index.js";
import AuthService from "@/services/AuthService";
import apiPath from "@/constants/api";

export default () => {
  let apiHeaders = {
    "Content-Type": "application/json"
  };

  let token = localStorage.getItem("token");
  let lang = localStorage.getItem("language");
  if (!lang) {
    localStorage.setItem("language", "lang-mon");
  }

  if (token !== null) apiHeaders["MY_TOKEN"] = token;
  if (lang !== null) apiHeaders["x-umoney-language"] = lang;

  let apiRequest = axios.create({
    headers: apiHeaders
  });

  apiRequest.interceptors.request.use(function (config) {
    if (config.data !== undefined) {
      let body = config.data;
      let str = JSON.stringify(body);
      str = str.replace(/=/g, "★~eq~★");
      str = str.replace(/&/g, "★~and~★");
      config.data = JSON.parse(str);
    }
    return config;
  });

  let retryCount = 0;

  apiRequest.interceptors.response.use(
    response => {
      return response;
    },
    function (error) {
      if (typeof error.response === "undefined") {
        retryCount += 1;
        if (retryCount <= 2) {
          return apiRequest(error.config);
        } else {
          return Promise.reject(error);
        }
      } else {
        if (error.response.status === 401) {
          if (error.response.request.responseURL != apiPath.userInfo)
            AuthService.logout().then(response => {
              if (response.status == 200) {
                store.dispatch("setUser", null);
                localStorage.setItem("isUserLogged", false);
                router.replace("/signin");
              }
            });
        }
        // check error toast
        else if (error.response.data.payload.toast != null) {
          showToast(getCaption(error.response.data.payload.toast), false);
        } else if (error.response.status == 500) {
          let msg = getCaption("caption.error_toast", false);
          showToast(msg);
        }

        return Promise.reject(error);
      }
    }
  );

  return apiRequest;
};

export const OtherApi = function () {
  let apiHeaders = {
    "Content-Type": "application/json"
  };

  let apiRequest = axios.create({
    headers: apiHeaders
  });

  return apiRequest;
};
